module.exports = __webpack_public_path__ + "img/BG_yellow.2236a335.jpg";